import React from "react";
import Layout from "./components/Layout";
import "./i18n";

const App: React.FC = () => {
  return <Layout />;
};

export default App;
